import { Record } from 'immutable';

export default Record({
  sidebarOpened: true,
  isByPassMaintenanceMode: false,
  systemStatus: {
    isSystemDown: false,
    restoreDate: null,
  },
});
